(function(){
  if (window.__rjOpts) return; window.__rjOpts = true;
  var GOLD_ORDER = ['14K Plated','18K Plated','14K Solid','18K Solid'];
  var COLOR_ORDER = ['Yellow','White','Rose'];
  var COLOR_BG = {Yellow:'linear-gradient(135deg,#f6dd8a,#c99a2e)', White:'linear-gradient(135deg,#fdfdfd,#c4c4c4)', Rose:'linear-gradient(135deg,#f7cdbb,#c98a72)'};
  function parseMetal(v){
    var k = v.match(/(\d{2})\s*k/i), c = v.match(/yellow|white|rose/i);
    if (!k || !c) return null;
    var plated = /plated|plating/i.test(v);
    var col = c[0].charAt(0).toUpperCase()+c[0].slice(1).toLowerCase();
    return {gold: k[1]+'K '+(plated?'Plated':'Solid'), color: col};
  }
  function isMetalName(n){ return /metal|material|melal|gold/i.test(n); }
  function isSizeName(n){ return /size|length/i.test(n); }
  function radios(fs){ return Array.prototype.slice.call(fs.querySelectorAll('input[type=radio]')); }
  function checkedVal(fs){ var r = fs.querySelector('input[type=radio]:checked'); return r ? r.value : null; }
  function pick(fs, val){
    var r = radios(fs).filter(function(x){ return x.value === val; })[0];
    if (r && !r.checked){ var l = fs.querySelector('label[for="'+r.id+'"]'); (l||r).click(); }
  }
  function enhanceMetal(wrap, fs, nameLabel){
    var vals = radios(fs).map(function(r){ return r.value; });
    var map = {}, golds = [], colors = [], others = [];
    vals.forEach(function(v){
      var p = parseMetal(v);
      if (!p){ others.push(v); return; }
      map[p.gold+'|'+p.color] = v;
      if (golds.indexOf(p.gold) < 0) golds.push(p.gold);
      if (colors.indexOf(p.color) < 0) colors.push(p.color);
    });
    if (golds.length < 2 && colors.length < 2) return;
    golds.sort(function(a,b){ return GOLD_ORDER.indexOf(a)-GOLD_ORDER.indexOf(b); });
    colors.sort(function(a,b){ return COLOR_ORDER.indexOf(a)-COLOR_ORDER.indexOf(b); });
    var box = document.createElement('div'); box.className = 'rj-opt';
    box.innerHTML =
      '<div class="rj-opt__row"><div class="rj-opt__label">Metal: <span class="rj-gold-cur"></span></div><div class="rj-opt__btns rj-gold"></div></div>'+
      '<div class="rj-opt__row rj-color-row"><div class="rj-opt__label">Color: <span class="rj-color-cur"></span></div><div class="rj-opt__sw rj-color"></div></div>';
    var gBox = box.querySelector('.rj-gold'), cBox = box.querySelector('.rj-color');
    golds.concat(others).forEach(function(g){
      var b = document.createElement('button'); b.type='button'; b.className='rj-btn'; b.textContent=g; b.dataset.g=g; gBox.appendChild(b);
    });
    colors.forEach(function(c){
      var b = document.createElement('button'); b.type='button'; b.className='rj-sw'; b.dataset.c=c; b.setAttribute('aria-label',c);
      b.innerHTML = '<span class="rj-sw__dot" style="background:'+COLOR_BG[c]+'"></span><span class="rj-sw__txt">'+c+'</span>';
      cBox.appendChild(b);
    });
    var state = {gold:null,color:null};
    function sync(){
      var cur = checkedVal(fs) || vals[0], p = parseMetal(cur);
      if (p){ state.gold=p.gold; state.color=p.color; } else { state.gold=cur; state.color=null; }
      box.querySelector('.rj-gold-cur').textContent = state.gold;
      box.querySelector('.rj-color-cur').textContent = state.color || '';
      box.querySelector('.rj-color-row').style.display = state.color ? '' : 'none';
      gBox.querySelectorAll('.rj-btn').forEach(function(b){ b.classList.toggle('is-active', b.dataset.g===state.gold); });
      cBox.querySelectorAll('.rj-sw').forEach(function(b){
        b.classList.toggle('is-active', b.dataset.c===state.color);
        b.disabled = !map[state.gold+'|'+b.dataset.c];
      });
    }
    gBox.addEventListener('click', function(e){
      var b = e.target.closest('.rj-btn'); if (!b) return;
      var g = b.dataset.g;
      if (others.indexOf(g) >= 0){ pick(fs, g); }
      else {
        var c = (state.color && map[g+'|'+state.color]) ? state.color : colors.filter(function(x){ return map[g+'|'+x]; })[0];
        pick(fs, map[g+'|'+c]);
      }
      setTimeout(sync, 0);
    });
    cBox.addEventListener('click', function(e){
      var b = e.target.closest('.rj-sw'); if (!b || b.disabled) return;
      var v = map[state.gold+'|'+b.dataset.c]; if (v) pick(fs, v);
      setTimeout(sync, 0);
    });
    fs.addEventListener('change', function(){ setTimeout(sync,0); });
    wrap.classList.add('rj-hidden-orig');
    wrap.parentNode.insertBefore(box, wrap);
    sync();
  }
  function enhanceSize(wrap, fs, name){
    var vals = radios(fs).map(function(r){ return r.value; });
    if (vals.length < 5 || !vals.every(function(v){ return /^\s*\d+(\.\d+)?\s*(in|inch|inches|"|mm|cm)?\s*$/i.test(v); })) return;
    var box = document.createElement('div'); box.className='rj-opt';
    var sel = document.createElement('select'); sel.className='rj-select'; sel.setAttribute('aria-label', name);
    vals.forEach(function(v){ var o=document.createElement('option'); o.value=v; o.textContent=v; sel.appendChild(o); });
    box.innerHTML = '<div class="rj-opt__label">'+name+':</div>';
    var w = document.createElement('div'); w.className='rj-select-wrap'; w.appendChild(sel); box.appendChild(w);
    sel.value = checkedVal(fs) || vals[0];
    sel.addEventListener('change', function(){ pick(fs, sel.value); });
    fs.addEventListener('change', function(){ var c = checkedVal(fs); if (c) sel.value = c; });
    wrap.classList.add('rj-hidden-orig');
    wrap.parentNode.insertBefore(box, wrap);
  }
  function init(){
    var forms = document.querySelectorAll('form[id^="AddToCartForm-"][id$="__main"]');
    forms.forEach(function(form){
      form.querySelectorAll('.selector-wrapper').forEach(function(wrap){
        var fs = wrap.querySelector('fieldset.single-option-radio'); if (!fs) return;
        var lab = wrap.querySelector(':scope > label'); if (!lab) return;
        var name = (lab.childNodes[0] ? lab.childNodes[0].textContent : lab.textContent).replace(/[:\s]+$/,'').trim();
        try {
          if (isSizeName(name)) enhanceSize(wrap, fs, name.replace(/:$/,''));
          else if (isMetalName(name)) enhanceMetal(wrap, fs, name);
        } catch(e){ console.warn('rj-options', e); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
